<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="editingField ? 'Edit Custom Field' : 'Add Custom Field'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
  *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
    @if (loaded) {
      <form [formGroup]="form" novalidate action="#">
        <ng-container
          *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />
        <tidy-card>
          <tidy-row >
            <tidy-input
              formControlName="field_name"
              [form]="form.controls.field_name"
              label="Field Name"
              [icon]="'assets/svg/create.svg'"
              [errorMessage]="'Please enter a valid field name'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [label]="'Field Type'"
              [icon]="'assets/svg/list.svg'"
              [items]="fieldTypes"
              [form]="form.get('field_type')"
              formControlName="field_type"
              [submitted]="submitted" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [label]="'Visibility'"
              [icon]="'assets/svg/settings.svg'"
              [items]="visibilityTypes"
              [form]="form.get('visibility')"
              formControlName="visibility"
              [submitted]="submitted" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="default_value"
              [form]="form.controls.default_value"
              label="Fallback Value"
              [icon]="'assets/svg/code.svg'"
              [errorMessage]="'Please enter a valid fallback value'"
              [submitted]="submitted" />
          </tidy-row>
          @if (instance) {
            <tidy-row>
              <tidy-input
                formControlName="value"
                [form]="form.controls.value"
                label="Value"
                [icon]="'assets/svg/code.svg'"
                [errorMessage]="'Please enter a valid value'"
                [submitted]="submitted" />
            </tidy-row>
          }

          <tidy-row>
            <tidy-select
              [label]="'Model Type'"
              [icon]="'assets/svg/list.svg'"
              [items]="modelTypes"
              [form]="form.get('model_type')"
              formControlName="model_type"
              [submitted]="submitted" />
          </tidy-row>
        </tidy-card>
        <tidy-button
          [text]="editingField ? 'Save' : 'Add Custom Field'"
          class="primary"
          [action]="boundAddCustomField" />
      </form>

      @if (editingField) {
        <tidy-row class="text-center extra-top-padding extra-bottom-padding" style="margin-top: 2rem;">
          <tidy-text
            [body]="'Delete Custom Field'"
            class="red"
            (action)="deleteCustomField(editingField)" />
        </tidy-row>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
